import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import notify from '../../../utils/notify';
import {} from 'reactstrap';
import PageBreadcrumb from '../../../Components/Common/PageBreadcrumb';
import '../../TenderOpening/components/TenderOpening.css';
import AwardingTable from './AwardingTable';
import CreateAwardingModal from './CreateAwardingModal';
import useAwardingApi from '../hooks/useAwardingApi';
import {
  PROCUREMENT_TYPE_HEADER,
  unwrapAwardingDetail,
} from '../utils/awardingHelpers';

// This page lists Product Hydro awardings only (ProcurementTypeHeader = 1).
const PAGE_PROCUREMENT_TYPE_HEADER = PROCUREMENT_TYPE_HEADER.productHydro;

const AwardingList = ({
  endpoint = '/awarding',
  detailBasePath = '/apps-awarding/dtl',
  viewPath = '/apps-awarding/view',
  subtitle = 'Create awardings per procurement and follow them through to confirmation.',
  canCreate = true,
  title = 'Awarding',
}) => {
  const navigate = useNavigate();
  const { createAwarding } = useAwardingApi();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggleCreate = () => setIsCreateOpen(prev => !prev);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const handleNext = async draft => {
    setIsSubmitting(true);
    try {
      const result = await createAwarding({
        procurementNumber: draft.procurementNumber,
        procurementTypeHeader: Number(PAGE_PROCUREMENT_TYPE_HEADER),
        titleProcurement: draft.titleProcurement,
        procurementType: draft.procurementType,
        description: draft.description,
      });

      const created = unwrapAwardingDetail(result);
      if (!created?.id) {
        notify.warning(
          'The awarding was created but its ID was not returned. Refresh the list to find it.'
        );
        return;
      }

      setIsCreateOpen(false);
      navigate(`/apps-awarding/dtl/${created.id}`);
    } catch (error) {
      notify.apiError(error, 'create awarding');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4'>
            <div className='to-hero mb-4'>
              <PageBreadcrumb fallback={{ label: title, to: viewPath }} />

              <div className='d-flex align-items-center gap-3 flex-wrap'>
                <span className='to-hero-icon'>
                  <i className='ri-award-line' aria-hidden='true' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='to-hero-title'>{title}</h4>
                  <p className='to-hero-subtitle'>{subtitle}</p>
                </div>
                <div className='d-flex gap-2 flex-wrap'>
                  <button
                    type='button'
                    className='to-hero-btn'
                    onClick={handleRefresh}
                  >
                    <i className='ri-refresh-line' aria-hidden='true' />
                    Refresh
                  </button>
                  {canCreate && (
                    <button
                      type='button'
                      className='to-hero-btn to-hero-btn--solid'
                      onClick={toggleCreate}
                    >
                      <i className='ri-add-line' aria-hidden='true' />
                      Create Awarding
                    </button>
                  )}
                </div>
              </div>
            </div>

            <AwardingTable
              procurementTypeHeader={PAGE_PROCUREMENT_TYPE_HEADER}
              refreshTrigger={refreshTrigger}
              endpoint={endpoint}
              detailBasePath={detailBasePath}
              onCreate={canCreate ? toggleCreate : undefined}
              exportName='Product Hydro'
            />
          </div>
        </div>
      </div>

      {canCreate && (
        <CreateAwardingModal
          isOpen={isCreateOpen}
          toggle={toggleCreate}
          onNext={handleNext}
          isSubmitting={isSubmitting}
        />
      )}
    </React.Fragment>
  );
};

export default AwardingList;
